<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

@if (!phones.length) {
  <profile-pds-p-text p-text color="contrast-medium">{{ 'pidpaw.selectPhone.button.emptyState.label' | translate }} </profile-pds-p-text>
}

@if (phones.length) {
  <div>
    @if (showListItem && !isEditMode) {
      <div class="profile:inline-flex profile:flex-col profile:lg:flex-row profile:flex-wrap">
        @for (phone of phones; track phone.id) {
          <div
            data-protractor-id="phone-list-item"
            class="profile:relative profile:mb-fluid-md profile:min-w-60 profile:max-xs:min-w-[320px] profile:max-sm:not-last:me-static-lg profile:max-sm:mt-0 profile:max-xs:first:mt-0 profile:grow"
          >
            <div class="profile:inline-flex">
              @if (phone.isPorscheId === true) {
                <profile-pds-p-icon p-icon name="lock" aria-hidden="true" color="contrast-medium" size="2xs"></profile-pds-p-icon>
              }
              @if (phone.phoneType === 'mobile' && phone.isPorscheId === false) {
                <profile-pds-p-icon p-icon name="mobile" aria-hidden="true" color="contrast-medium" size="2xs"></profile-pds-p-icon>
              }
              @if (phone.phoneType === 'landline' && (phone.isPorscheId === false || phone.isPorscheId === undefined)) {
                <profile-pds-p-icon p-icon name="phone" aria-hidden="true" color="contrast-medium" size="2xs"></profile-pds-p-icon>
              }
              @if (phone.isPorscheId === true) {
                <profile-pds-p-text
                  p-text
                  size="inherit"
                  color="contrast-medium"
                  class="profile:text-[14px] profile:ms-static-xs profile:inline-block"
                  >{{ 'pidp.personalData.emailAddresses.porscheID.label' | translate }}
                </profile-pds-p-text>
              }
              @if (phone.phoneType === 'mobile' && phone.isPorscheId === false) {
                <profile-pds-p-text
                  p-text
                  size="inherit"
                  class="profile:text-[14px] profile:inline-block profile:ms-static-xs"
                  color="contrast-medium"
                  >{{ 'pidpaw.editPhone.icon.phoneTypeMobile.label' | translate }}
                </profile-pds-p-text>
              }
              @if (phone.phoneType === 'landline' && (phone.isPorscheId === false || phone.isPorscheId === undefined)) {
                <profile-pds-p-text
                  p-text
                  size="inherit"
                  class="profile:text-[14px] profile:inline-block profile:ms-static-xs"
                  color="contrast-medium"
                  >{{ 'pidpaw.editPhone.icon.phoneTypeLandline.label' | translate }}
                </profile-pds-p-text>
              }
            </div>
            <profile-pds-p-text p-text size="inherit" class="profile:text-[20px]">
              <div
                data-protractor-id="formatted-number"
                class="fs-exclude"
                dir="ltr"
                [innerHTML]="phone.number | formattedNumber: country"
              ></div>
            </profile-pds-p-text>
            @if (phone.id !== phoneBeingEdited?.id) {
              <div class="profile:flex profile:flex-row profile:gap-x-static-md">
                @if (!isCnUser || (isCnUser && !restrictGlobalUIChanges)) {
                  @if (!phone.isStandard || (phone.isStandard && !phone.isVerified)) {
                    <div>
                      <profile-pds-p-button-pure
                        p-button-pure
                        icon="edit"
                        (click)="editItem(phone)"
                        [attr.id]="'edit-phone-btn-' + phone.id"
                        class="profile:py-fluid-sm"
                        [aria]="{
                          'aria-label':
                            ('pidpaw.selectPhone.button.editPhone.labelA11y'
                            | translate: { PHONE_NUMBER: getFormattedPhoneForAria(phone) }),
                        }"
                        [myprofileUiTrack]="{
                          clickElementType: 'button',
                          clickElementId: 'phonenumber',
                          clickElementName: 'edit',
                        }"
                      >
                        {{ 'pidpaw.generic.button.edit.label' | translate }}
                      </profile-pds-p-button-pure>
                    </div>
                  }
                  @if (!phone.isPorscheId) {
                    <div>
                      <profile-pds-p-button-pure
                        p-button-pure
                        icon="delete"
                        (click)="deleteItem(phone)"
                        class="profile:py-fluid-sm"
                        [aria]="{
                          'aria-label':
                            ('pidpaw.selectPhone.button.deletePhone.labelA11y'
                            | translate: { PHONE_NUMBER: getFormattedPhoneForAria(phone) }),
                          'aria-haspopup': 'dialog',
                        }"
                        data-protractor-id="phone-widget-editor-delete-phone-number-button"
                        [myprofileUiTrack]="{
                          clickElementType: 'button',
                          clickElementId: 'phonenumber',
                          clickElementName: 'delete',
                        }"
                      >
                        {{ 'pidpaw.generic.button.delete.label' | translate }}
                      </profile-pds-p-button-pure>
                    </div>
                  }
                  @if (phone.isPorscheId && phone.isStandard) {
                    <div>
                      <div class="profile:mt-0">
                        <profile-pds-p-button-pure
                          [aria]="{ 'aria-label': ('pidpaw.selectPhone.button.changePorscheId.aria' | translate) }"
                          id="goToChangePorscheIdPage"
                          p-button-pure
                          (click)="goToChangePorscheIdPage()"
                          class="profile:py-fluid-sm"
                          [myprofileUiTrack]="{
                            clickElementType: 'link',
                            clickElementId: 'email_address',
                            clickElementName: 'goto_change_porsche_id_link',
                          }"
                          >{{ 'pidp.personalData.emailAddresses.changePorscheIDLink.label' | translate }}
                        </profile-pds-p-button-pure>
                      </div>
                    </div>
                  }
                }
              </div>
            }
          </div>
        }
      </div>
    }
    @if (isEditMode || isVerificationMode) {
      <div>
        <div>
          @if (isEditMode) {
            <myprofile-phone-editform
              [hasConfirmedVehicle]="hasConfirmedVehicle"
              (goToChangePorscheIdPageEvent)="goToChangePorscheIdPage()"
            ></myprofile-phone-editform>
          }
          @if (isVerificationMode) {
            <myprofile-phone-verification
              (cancelEvent)="cancelVerification()"
              (verified)="this.verificationSuccessful.emit()"
            ></myprofile-phone-verification>
          }
        </div>
      </div>
    }
  </div>
}

@if (listHasLoadingOverlay$ | async) {
  <pidx-loader [mode]="PidxLoaderModeEnum.OVERLAY" [loadingLabel]="'phoneWidget.general.savingStatus' | translate"></pidx-loader>
}
